import { ClientManager } from '@algorandfoundation/algokit-utils/types/client-manager'
import { algodConfig } from './config'

export const algodClient = ClientManager.getAlgodClient({
  server: algodConfig.server,
  port: algodConfig.port,
  token: algodConfig.token
})
